export type ILimitService = ReturnType<typeof limitServiceFactory>;

/* @ngInject */
export function limitServiceFactory(heightCalc) {
  const limit = {
    amount: 3,
  };

  return {
    limit,
    showMore,
  };

  function showMore() {
    limit.amount += 3;
    heightCalc.scrollInit();
  }

  function setAmount(newAmount) {
    limit.amount = newAmount;
  }
}
